export default __webpack_public_path__ + "static/media/border-vertical-1.d7df161c.png";